import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import styles from './_friendsHeader.css'
import PageHeader from 'components/util/PageHeader'
import { FormattedMessage } from 'react-intl'

function FriendsHeader (props) {
  const { isProfilePrivate } = props
  // Applying a CSS modules class with the react-router activeClassName prop is not working.
  // Manually adding the styles with the activeStyle prop.
  const ACTIVE = {
    boxShadow: 'inset 0 3px 0 0px #2F98D9',
    background: '#FFFFFF',
    color: '#444444',
  }
  return (
    <div>
      <PageHeader>
        <h1>
          <FormattedMessage id='friends.mainheader' defaultMessage='My Friends' />
        </h1>
      </PageHeader>
      { isProfilePrivate ? null :
        <div className={styles.tabsContainer}>
          <NavLink
            exact
            className={styles.tab}
            activeStyle={ACTIVE}
            to='/people/friends'>
            <FormattedMessage id='friends.tab.myfriends' defaultMessage='My Friends' />
          </NavLink>

          <NavLink
            className={styles.tab}
            activeStyle={ACTIVE}
            to='/people/friends/find'>
            <FormattedMessage id='friends.tab.findfriends' defaultMessage='Find Friends' />
          </NavLink>

          <NavLink
            className={styles.tab}
            activeStyle={ACTIVE}
            to='/people/friends/invite'>
            <FormattedMessage id='friends.tab.invitefriends' defaultMessage='Invite Friends' />
          </NavLink>
        </div>
      }
    </div>
  )
}

FriendsHeader.propTypes = {
  isProfilePrivate: PropTypes.bool,
}

export default FriendsHeader
